import React, { ReactElement, FunctionComponent, memo, useMemo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Image from '../../../Image'
import PlayerImage from '../../../Image/Player'
import TeamImage from '../../../Image/Team'
import { FavoriteItemProps } from '..'

export type FavoriteImageProps = Pick<FavoriteItemProps, 'imageUrl' | 'alt' | 'type' | 'iconProps'>

const FavoriteImage: FunctionComponent<FavoriteImageProps> = ({
    imageUrl,
    type,
    alt,
    iconProps,
}): ReactElement => {
    const imageComponent = useMemo(() => {
        if (type === 'ICON' && iconProps) {
            return <FontelloIcon {...iconProps} />
        } else if (type === 'PLAYER') {
            return <PlayerImage imageUrl={imageUrl} alt={alt} size="S" width={36} />
        } else if (type === 'TEAM') {
            return <TeamImage imageUrl={imageUrl} alt={alt} size="S" width={36} />
        }
        return (
            <Grid noExpand padding={1} borderRadius={2} backgroundColor="tahitian-5">
                <Image imageUrl={imageUrl} alt={alt} aspectRatio="1:1" width={34} size="S" />
            </Grid>
        )
    }, [iconProps, type, imageUrl, alt])

    return (
        // TODO: tahitian-4 color is wrong here since many Competition Images have dark labels in it...
        <Grid
            borderRadius={31}
            width={62}
            height={62}
            marginX={3}
            marginBottom={3}
            noExpand
            center
            backgroundColor="tahitian-4"
        >
            {imageComponent}
        </Grid>
    )
}

export default memo(FavoriteImage)
